import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NavbarComponent } from './navbar.component';
var NavbarModule = (function () {
    function NavbarModule() {
    }
    return NavbarModule;
}());
export { NavbarModule };
NavbarModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [NavbarComponent],
                exports: [NavbarComponent]
            },] },
];
/** @nocollapse */
NavbarModule.ctorParameters = function () { return []; };
//# sourceMappingURL=navbar.module.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/navbars/navbar.module.js
// module id = ../../../../angular-bootstrap-md/navbars/navbar.module.js
// module chunks = 3